import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MobileCenteredLayout } from '@/components/MobileCenteredLayout/MobileCenteredLayout';
import { WelcomeFooter } from '@/components/WelcomeFooter/WelcomeFooter';
import { SelfieValidationHeader } from '@/Pages/Selfie/components/SelfieValidationHeader';
import { SelfieValidationIcon } from '@/Pages/Selfie/components/SelfieValidationIcon';
import { SelfieValidationProgress } from '@/Pages/Selfie/components/SelfieValidationProgress';
import { useSelfieValidation } from '@/Pages/Selfie/hooks/useSelfieValidation';
import { parseSelfieValidatingLocationState } from '@/Pages/Selfie/types/selfieValidatingLocationState';
import '@/Pages/Selfie/SelfiePage.sass';

export function SelfieValidationPage(): JSX.Element | null {
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = parseSelfieValidatingLocationState(location.state);

  useEffect(() => {
    if (locationState === null) {
      navigate('/error', { replace: true, state: { errorType: 'generic' } });
    }
  }, [locationState, navigate]);

  if (locationState === null) {
    return null;
  }

  return <SelfieValidationPageContent sessionId={locationState.sessionId} />;
}

type ContentProps = { sessionId: string }

function SelfieValidationPageContent({ sessionId }: ContentProps): JSX.Element {
  const { progress } = useSelfieValidation({ sessionId });

  return (
    <MobileCenteredLayout>
      <Box
        component="main"
        className="selfie-validation-page"
        data-testid="selfie-validation-page"
      >
        <Box className="selfie-validation-page__content">
          <SelfieValidationIcon />
          <SelfieValidationHeader />
          <SelfieValidationProgress progress={progress} />
        </Box>
        <WelcomeFooter />
      </Box>
    </MobileCenteredLayout>
  );
}
